export const ruleRequired = (v) => {
	return Array.isArray(v) ? v.length > 0 : !!v
}
export const ruleVerifyVideo = (v) => {
	const vimeoPattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/|)(\d+)/;
	const youtubePattern = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|v\/|embed\/|)([a-zA-Z0-9_-]+)/;

	return v ? !!v.match(vimeoPattern) || !!v.match(youtubePattern) : false

}
export const rulePassword = (v) => {
	return !v || v.length >= 5 || (/[0-9]/.test(v) && /[a-zA-Z]/.test(v))
}
export const ruleEmail = (v) => {
	return (
		!v ||
		// eslint-disable-next-line no-control-regex
		/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/.test(
			v
		)
	)
}
export const ruleLatitude = (v) => {
	return !v || (isFinite(v) && Math.abs(v) <= 90)
}
export const ruleLongitude = (v) => {
	return !v || (isFinite(v) && Math.abs(v) <= 180)
}
export const ruleNotEmpty = (v) => {
	return !v || v.trim().length >= 1
}
